/**
 * Merged Document API Service (TASK-188, AC-3 / FR-004)
 *
 * API client for the read-only Merged Document Viewer. Returns the merged +
 * annotated document exactly as the segmenter "sees" it (source headers,
 * service-start / -end markers, orphan text) plus the service boundaries.
 */
import apiClient from './client';

/**
 * A single service boundary in the annotated document.
 * `matched` means the marked scope was successfully matched to a real Service.
 */
export interface Boundary {
  scope_id: string;
  service_name: string;
  service_type: string;
  is_aggregator: boolean;
  start: number;
  end: number;
  matched: boolean;
}

export interface MergedDocument {
  /** Plain merged document (source headers only, no service markers). */
  raw_content: string;
  /** Merged document with TEXT markers (<<< Услуга / >>> конец / === ИСТОЧНИК). */
  annotated_content: string;
  boundaries: Boundary[];
  generated_at: string;
}

export const mergedDocumentApi = {
  /**
   * Get the merged + annotated document for the current organization.
   * 404 if no indexing has happened yet.
   */
  get: async (): Promise<MergedDocument> => {
    const { data } = await apiClient.get<MergedDocument>(
      '/api/v1/merged-document/'
    );
    return data;
  },
};

export default mergedDocumentApi;
